(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aura-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aura-product-recommendations')) {
    customElements.define(
      'aura-product-recommendations',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.recommendationsPerformed === 'true') return;
          this.observer = new IntersectionObserver(
            (entries) => {
              if (!entries[0]?.isIntersecting) return;
              this.observer.disconnect();
              this.loadRecommendations();
            },
            { rootMargin: '0px 0px 400px 0px' }
          );
          this.observer.observe(this);
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }

        async loadRecommendations() {
          const { url, productId, sectionId, intent } = this.dataset;
          if (!url || !productId || !sectionId) return;
          try {
            const response = await fetch(
              `${url}&product_id=${productId}&section_id=${sectionId}&intent=${intent}`
            );
            if (!response.ok) return;
            const html = await response.text();
            const documentFragment = new DOMParser().parseFromString(html, 'text/html');
            const updated = documentFragment.querySelector(
              `aura-product-recommendations[data-section-id="${sectionId}"]`
            );
            if (!updated || updated.hidden) {
              this.remove();
              return;
            }
            this.replaceWith(updated);
          } catch (error) {
            this.dataset.recommendationsError = 'true';
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
